import React, { useEffect, useState } from 'react';

import {
  getLocalIsActive,
  updateLocalStorage
} from '../../javascripts/helpers/localstorage';

type WatchListBtnProps = {
  id: string;
  labels: {
    add: string;
    remove: string;
  };
  title: string;
};

const WatchListBtn = ({ id, labels, title }: WatchListBtnProps) => {
  const [isActive, setIsActive] = useState(false);

  const onClick = () => {
    updateLocalStorage(id, title, !isActive);
    setIsActive(!isActive);
  };

  useEffect(() => {
    if (isActive !== getLocalIsActive(id)) {
      setIsActive(!isActive);
    }
  }, []);

  return (
    <button
      type="button"
      className={`watchlist-btn watchlist-btn--greige ${
        isActive ? 'watchlist-btn--active' : ''
      }`}
      onClick={onClick}
    >
      <div
        className="watchlist-btn__tooltip typo-button font-uppercase"
        aria-hidden="true"
      >
        <p className="watchlist-btn__tooltip-add">{labels.add}</p>
        <p className="watchlist-btn__tooltip-remove">{labels.remove}</p>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className="watchlist-btn__icon watchlist-btn__icon-add"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 12L2.5 16V0H13.5V16L8 12ZM11.7 12.4652L8 9.77431L4.3 12.4652V1.8H11.7V12.4652Z"
          fill="black"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className="watchlist-btn__icon watchlist-btn__icon-remove"
      >
        <path d="M2.5 0H8H13.5V16L8 12L2.5 16V0Z" fill="#5395E0" />
      </svg>
    </button>
  );
};

export default WatchListBtn;
